
export const eventTypeEnum = [
    { key: '1', value: '1', text: 'Conference' },
    { key: '2', value: '2', text: 'Seminar' },
    { key: '3', value: '3', text: 'Symposium' },
    { key: '4', value: '4', text: 'Workshop' }
]

export const radioValuesEnum = (fieldName) => [{ id: fieldName + '-0', label: 'Yes', value: '1' }, { id: fieldName + '-1', label: 'No', value: '0' }]

export const howManyCoChairEnum = [
    { key: '1', value: '1', text: '1' },
    { key: '2', value: '2', text: '2' },
    { key: '3', value: '3', text: '3' }
]

export const TemplateFileEnum = {
    EventTypes: 'Event Types.pdf',
    SymposiaChairResponsibilities: 'SymposiaChairResponsibilities.pdf',
    WorkshopChairResponsibilities: 'Workshop Chair Responsibilities.pdf',
    HandBook: 'agenda-templates/Handbook.pdf',
    SubcommitteeAgendaTemplate: 'agenda-templates/ExecutiveSubcommitteeAgendaTemplate.doc',
    MainCommintteeAgendaTemplate: 'agenda-templates/MainCommitteeAgendaTemplate.doc'
}

export const typeOfAstmPublisherEnum = [
    { key: '1', value: '1', text: 'Selected Technical Papers (STP)' },
    { key: '2', value: '2', text: 'ASTM Journal Special Issue' },
    { key: '3', value: '3', text: 'Undecided; Need more information' }
]

export const howManySessionsEnum = [
    { key: '1', value: '1', text: '1' },
    { key: '2', value: '2', text: '2' },
    { key: '3', value: '3', text: '3' },
    { key: '4', value: '4', text: '4' },
    { key: '5', value: '5', text: '5' }
]

export const CountryRangeEnum = {
    'US': 'US',
    'CA': 'CA'
}

export const CreatedBy = -1

export const defaultEndTime = '08:00'

export const eventstatusEnum = { Cancelled: 'Cancelled', Live: 'Live', PreEvent: 'Pre-Event', SoldOut: 'Sold Out' }

export const eventtypeEnum = { CommitteeWeek: 'CommitteeWeek', IndependentMeeting: 'IndependentMeeting' }

export const meetingsymposiatypeEnum = { Meeting: 'Meeting', Symposia: 'Symposia' }

export const maxEventLimit = 9

export const future_Committee_Week_File_Name = 'Future_CW_Chart_2021.pdf'

export const imageUrl = process.env.REACT_APP_ASTM_LOGO_EVENT_IMAGE_URL

export const canceledLable = 'Canceled'

export const isVisibleCovidMessage = false

export const radioTimeFormatEnum = (fieldName) => [{ id: fieldName + '-0', label: 'AM', value: 'AM' }, { id: fieldName + '-1', label: 'PM', value: 'PM' }]

export const BucketEnum = {
    IN_BOUND: 'in',
    OUT_BOUND: 'out'
}

export const MY_AGENDA = 'myagenda';

// TODO : get domain prefix to set cookies doamin wise.
export const getDoaminPrefix = () => {
    const hostname = window.location.hostname;
    let prefixName = '';
    if (hostname) {
        let envPrefix = hostname.indexOf('-') > -1 ? hostname.split('-') : '';
        if (envPrefix && envPrefix.length > 0) {
            prefixName = `${envPrefix[0].toUpperCase()}`;
            if (prefixName == 'QA') {
                prefixName = 'TEST'
            }
            if (['DEV', 'TEST', 'STAGE'].includes(prefixName)) {
                prefixName = prefixName + '-';
            }
        }
    }
    return prefixName;
}

export const cookieKeysEnum = {
    '_MyASTM': '_MyASTM',
    'APP_SESSIONID': `${getDoaminPrefix()}MCS-APP-SESSION-ID`,
    'ILSCookie': 'MCS-ILS-COOKIE',
    'IS-OKTA-VERIFIED': `${getDoaminPrefix()}IOV`,
    'ACCOUNT-ID': 'MCS-ACCOUNT-ID',
    'REDIRECT-URL': `${getDoaminPrefix()}REDIRECT-URL`,
    'APP-DATA': `${getDoaminPrefix()}APP-DATA`,
    'TRIED-LOGIN': `${getDoaminPrefix()}TRIED-LOGIN`,
    'BANNER-DISPLAY': `${getDoaminPrefix()}BANNER-DISPLAY`
}

export const MemberAppNavUrls = [
    `${process.env.REACT_APP_MEETING_BASE_URL}/MyAgenda`,
    `${process.env.REACT_APP_MEETING_BASE_URL}/MyMeetingMaterial`,
    `${process.env.REACT_APP_MEETING_BASE_URL}/MySchedule`
]

export const membershipTypeJSON = {
    honorary: {
        id: 1,
        externalKey: "honorary",
        displayName: "Honorary Member"
    },
    perpetualInstitution: {
        id: 2,
        externalKey: "perpetualInstitution",
        displayName: "Perpetual Institution Member"
    },
    organizational: {
        id: 3,
        externalKey: "organizational",
        displayName: "Organizational Member"
    },
    affilate: {
        id: 4,
        externalKey: "affilate",
        displayName: "Affilate Member"
    },
    memberInstitution: {
        id: 5,
        externalKey: "memberInstitution",
        displayName: "Institution Member"
    },
    participating: {
        id: 6,
        externalKey: "participating",
        displayName: "Participating Member"
    },
    informational: {
        id: 7,
        externalKey: "informational",
        displayName: "Informational Member"
    },
    exemptMember: {
        id: 8,
        externalKey: "exemptMember",
        displayName: "Exempt Member"
    },
    seniorMember: {
        id: 9,
        externalKey: "senior",
        displayName: "Senior Member"
    },
    lifeMember: {
        id: 10,
        externalKey: "lifeMember",
        displayName: "Life Member"
    },
    perpetualIndustry: {
        id: 11,
        externalKey: "perpetualIndustry",
        displayName: "Perpetual Industry Member"
    },
    temporary: {
        id: 12,
        externalKey: "temporary",
        displayName: "Temporary Member"
    },
    isoJoint: {
        id: 13,
        externalKey: "isoJoint",
        displayName: "ISO/JOINT Member"
    },
    represntative: {
        id: 14,
        externalKey: "represntative",
        displayName: "Represntative Member"
    },
    newMember: {
        id: 15,
        externalKey: "newMember",
        displayName: "New Member"
    },
    cooperativeAgreement: {
        id: 16,
        externalKey: "cooperativeAgreement",
        displayName: "Cooperative Agreement Member"
    },
    student: {
        id: 17,
        externalKey: "student",
        displayName: "Student Member"
    },
    mouMember: {
        id: 18,
        externalKey: "mouMember",
        displayName: "MOU Member"
    },
    GovtRepresentative: {
        id: 19,
        externalKey: "GovtRepresentative",
        displayName: "Govt Representative"
    },
    CooperativeAgreementRep: {
        id: 20,
        externalKey: "CooperativeAgreementRep",
        displayName: "Cooperative Agreement Representative"
    }
}

export const nameFormatTypeEnum = {
    'FL': 1,
    'LF': 2,
    'LFM': 3,
    'FML': 4
}

export const myMeetingMaterialSteps = [
    'EVENT',
    'COMMITTEE',
    'MEETING',
    'REVIEW',
    'CONFIRM'
]

export const myScheduleSteps = {
    EVENT: 'Event',
    COMMITTEE: 'Committee',
    MEETINGS: 'Meetings',
    CREATE: 'Create Schedule'
}

export const myScheduleStepDetails = [
    { count: 0, stepName: myScheduleSteps.EVENT },
    { count: 1, stepName: myScheduleSteps.COMMITTEE },
    { count: 2, stepName: myScheduleSteps.MEETINGS },
    { count: 3, stepName: myScheduleSteps.CREATE }
]

export const myMeetingMaterialRadioEnum = (fieldName) => [{ id: fieldName + '-0', label: 'Include material for Main Committee and Subcommittees to which I belong.', value: fieldName + '-0' }, { id: fieldName + '-1', label: 'Include all material for the selected committee.', value: fieldName + '-1' }]

export const myScheduleRadio = (fieldName) => [{ id: fieldName + '-0', label: 'Include Main Committee meetings and all meetings of Subcommittees to which I belong.', value: fieldName + '-0' }, { id: fieldName + '-1', label: 'Include all meetings on the schedule.', value: fieldName + '-1' }]
export const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const createScheduleButtonArray = ['Recreate schedule', 'Create schedule'];
export const myScheduleDownloadExcelName = 'MySchedule';
export const textInvalidDate = "Invalid date";

export const sortByMultipleKey = (keys) =>
    (a, b) => {
        if (keys.length == 0) return 0; // force to equal if keys run out
        let key = keys[0]; // take out the first key
        if (a[key] < b[key]) return -1; // will be 1 if DESC
        else if (a[key] > b[key]) return 1; // will be -1 if DESC
        return sortByMultipleKey(keys.slice(1))(a, b);
    }

export const calFileImportInstruction = 'CalFileImportInstruction.pdf';
export const customMeetings = 'Custom'

export const IDENTITY_DELEGATION_FLAG = 'IdentityDelegation';

export const USER_INFO = 'user-info';

export const CreatSchedule_DateTimeFilter = 1;

export const CreatSchedule_LocationFilter = 2;

export const SESSION_STORAGE_KEYS = {
    "REDIRECT_CALLBACK_URL":"REDIRECT_CALLBACK_URL",
    "REDIRECT_URL":"REDIRECT_URL",
    "STATIC_REDIRECT_URL":"STATIC_REDIRECT_URL"
}

export const pageLinkEnum = [
    {
        label: 'All',
        value: 0,
        link: process.env.REACT_APP_CATALOG_SEARCH
    },
    {
        label: 'Meetings & Symposia',
        value: 1,
        link: process.env.REACT_APP_MEETING_BASE_URL + '/search-keyword?keyword='
    },
    {
        label: 'Standardization News',
        value: 2,
        link: process.env.REACT_APP_STANDARDIZATION_NEWS_SEARCH
    },
    {
        label: 'News Releases',
        value: 3,
        link: process.env.REACT_APP_NEWS_RELEASES_SEARCH
    },
    {
        label: "AllWithWCMS",
        value: 0,
        link: process.env.REACT_APP_WCMS_CATALOG_SEARCH
    },
]